import {
  Component,
  OnInit,
  ViewEncapsulation,
  Output,
  Input,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { ITaskInfo, IVehicleAddress } from '../../interfaces/task-info';
import { MapService } from '../../services';
import { TaskType } from '../../enums/task.type';

@Component({
  templateUrl: './display-route.component.html',
  selector: 'display-route',
  styleUrls: ['./display-route.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DisplayRouteComponent implements OnInit {
  @Output() taskTypeIdChange: EventEmitter<TaskType>;
  public _taskTypeId: TaskType;
  @Input('taskTypeId')
  public set taskTypeId(value: TaskType) {
    this._taskTypeId = value;
    switch (value) {
      case null:
      case undefined:
        this.taskType = '';
        break;
      case TaskType.DrivenPlated:
      case TaskType.DrivenUninsured:
      case TaskType.DriverInsured:
      case TaskType.DrivenEngineiusGo:
        this.taskType = 'Driven';
        break;
      case TaskType.UncoveredTransportedMovement:
      case TaskType.CoveredTransportedMovement:
        this.taskType = 'Transported';
        break;
      case TaskType.RecoveredSkates:
      case TaskType.RecoveredFullLiftOnly:
      case TaskType.RecoveredMoreEquipmentNeeded:
        this.taskType = 'Recovered';
        break;
      default:
        this.taskType = '';
    }
    this.taskTypeIdChange.emit(value);
  }

  public get taskTypeId(): TaskType {
    return this._taskTypeId;
  }

  @Output() taskTypeChange: EventEmitter<string>;
  public _taskType: string = '';
  @Input('taskType')
  public set taskType(value: string) {
    this._taskType = value;

    this.taskTypeChange.emit(value);
  }

  public get taskType(): string {
    return this._taskType;
  }

  @Output() pickupLocationChange: EventEmitter<IVehicleAddress>;
  public _pickupLocation: IVehicleAddress;
  @Input('pickupLocation')
  public set pickupLocation(value: IVehicleAddress) {
    this._pickupLocation = value;
    this.UpdateRouteInfo();
    this.pickupLocationChange.emit(value);
  }

  public get pickupLocation(): IVehicleAddress {
    return this._pickupLocation;
  }

  @Output() dropoffLocationChange: EventEmitter<IVehicleAddress>;
  public _dropoffLocation: IVehicleAddress;
  @Input('dropoffLocation')
  public set dropoffLocation(value: IVehicleAddress) {
    this._dropoffLocation = value;
    this.UpdateRouteInfo();
    this.dropoffLocationChange.emit(value);
  }

  public get dropoffLocation(): IVehicleAddress {
    return this._dropoffLocation;
  }

  @Output() pickupEarliestDateTimeChange: EventEmitter<Date>;
  private _pickupEarliestDateTime: Date;
  @Input('pickupEarliestDateTime')
  public set pickupEarliestDateTime(value: Date) {
    this._pickupEarliestDateTime = value;
    this.pickupEarliestDateTimeChange.emit(value);
  }

  public get pickupEarliestDateTime(): Date {
    return this._pickupEarliestDateTime;
  }

  public get isPickupLatestTime(): boolean {
    return this.pickupLatestDateTime != undefined;
  }

  @Output() pickupLatestDateTimeChange: EventEmitter<Date>;
  private _pickupLatestDateTime: Date;
  @Input('pickupLatestDateTime')
  public set pickupLatestDateTime(value: Date) {
    this._pickupLatestDateTime = value;
    this.pickupLatestDateTimeChange.emit(value);
  }

  public get pickupLatestDateTime(): Date {
    return this._pickupLatestDateTime;
  }

  public get isDropoffEarliestTime(): boolean {
    return this.dropoffEarliestDateTime != undefined;
  }

  @Output() dropoffEarliestDateTimeChange: EventEmitter<Date>;
  private _dropoffEarliestDateTime: Date;
  @Input('dropoffEarliestDateTime')
  public set dropoffEarliestDateTime(value: Date) {
    this._dropoffEarliestDateTime = value;
    this.dropoffEarliestDateTimeChange.emit(value);
  }

  public get dropoffEarliestDateTime(): Date {
    return this._dropoffEarliestDateTime;
  }

  public get isDropoffLatestTime(): boolean {
    return this.dropoffLatestDateTime != undefined;
  }

  @Output() dropoffLatestDateTimeChange: EventEmitter<Date>;
  private _dropoffLatestDateTime: Date;
  @Input('dropoffLatestDateTime')
  public set dropoffLatestDateTime(value: Date) {
    this._dropoffLatestDateTime = value;
    this.dropoffLatestDateTimeChange.emit(value);
  }

  public get dropoffLatestDateTime(): Date {
    return this._dropoffLatestDateTime;
  }

  @Output() routeInfoChange: EventEmitter<any>;
  private _routeInfo: any;
  @Input('routeInfo')
  public set routeInfo(value: any) {
    this._routeInfo = value;
    this.routeInfoChange.emit(value);
  }

  public get routeInfo(): any {
    return this._routeInfo;
  }

  private _height: number = 300;
  @Output() heightChange: EventEmitter<number>;

  @Input('height')
  set height(value: number) {
    this._height = value;
    this.heightChange.emit(value);
  }

  get height(): number {
    return this._height;
  }

  @Input() selectedTask?: ITaskInfo;

  constructor(private mapService: MapService) {
    this.pickupLocationChange = new EventEmitter<any>();
    this.dropoffLocationChange = new EventEmitter<any>();

    this.pickupEarliestDateTimeChange = new EventEmitter<Date>();
    this.pickupLatestDateTimeChange = new EventEmitter<Date>();
    this.dropoffEarliestDateTimeChange = new EventEmitter<Date>();
    this.dropoffLatestDateTimeChange = new EventEmitter<Date>();
    this.routeInfoChange = new EventEmitter<any>();
    this.heightChange = new EventEmitter<number>();
    this.taskTypeIdChange = new EventEmitter<TaskType>();
    this.taskTypeChange = new EventEmitter<string>();
  }

  ngOnInit() {}

  UpdateRouteInfo() {
    this.routeInfo = null;

    if (
      !this.pickupLocation ||
      !this.pickupLocation.latitude ||
      !this.pickupLocation.longitude ||
      !this.dropoffLocation ||
      !this.dropoffLocation.latitude ||
      !this.dropoffLocation.longitude
    ) {
      return;
    }

    const dto = this.mapService.GetRouteDTO(
      this.pickupLocation,
      this.dropoffLocation,
      this.pickupEarliestDateTime,
    );
    this.mapService.GetRoute(dto).then((route) => {
      if (route != null) {
        this.routeInfo = {
          distanceMiles: this.mapService.getMiles(route.distance),
          time: this.mapService.getDateTime(route.duration, 'hr', 'min'),
        };
      }
    });
  }

  CompareDatetime(date1: Date, date2: Date) {
    date1 = new Date(date1);
    date2 = new Date(date2);

    var millisec1 = date1.getTime();
    var millisec2 = date2.getTime();

    if (millisec1 == millisec2) {
      return 0;
    }

    if (millisec1 > millisec2) {
      return 1;
    }

    if (millisec1 < millisec2) {
      return -1;
    }

    return null;
  }

  timesChanged() {
    return (
      this.selectedTask != null &&
      (this.selectedTask.pickupEarliestDateTime !=
        this.selectedTask.originalPickupEarliestDateTime ||
        this.selectedTask.pickupLatestDateTime != this.selectedTask.originalPickupLatestDateTime ||
        this.selectedTask.pickupEarliestDateTime !=
          this.selectedTask.originalPickupEarliestDateTime ||
        this.selectedTask.pickupLatestDateTime != this.selectedTask.originalPickupLatestDateTime)
    );
  }
}
